import { QueryFilter } from "src/app/shared/models/query-filter.model";


export class PromoCodeQueryFilter extends QueryFilter {
    organizationId: string;
}